import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  HStack,
  StackDivider,
} from '@chakra-ui/react';

type ConfirmModalProps = {
  isOpen: boolean;
  title: string;
  children: React.ReactElement;
  onClose: () => void;
  onConfirm: () => void;
};

export default function ConfirmModal({
  isOpen,
  title,
  children,
  onClose,
  onConfirm,
}: ConfirmModalProps) {
  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalHeader textAlign="center" pb={0} fontSize="lg">
          {title}
        </ModalHeader>
        <ModalBody py={5}>{children}</ModalBody>
        <ModalFooter p={0} borderTopWidth="1px" borderColor="gray.300">
          <HStack w="full" divider={<StackDivider borderColor="gray.300" />}>
            <Button
              isFullWidth
              fontSize="sm"
              variant="unstyled"
              fontWeight="normal"
              onClick={onConfirm}
            >
              確定
            </Button>
            <Button
              isFullWidth
              fontSize="sm"
              variant="unstyled"
              fontWeight="normal"
              onClick={onClose}
            >
              我想一下
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
